<template>
    <div v-show="visible">
        <el-dialog title="通知家长" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="650px">      
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="400"
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name" label="学生姓名"  :show-overflow-tooltip="true" width="100"></el-table-column>
                <el-table-column prop="className"  label="所属班级" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="readSign" label="阅读标记" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.readSign == 1">
                            未读
                        </div>
                        <div v-else-if="scope.row.readSign == 2">
                            已读
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="sendCount" label="发送次数" width="100"></el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="send">一键通知</el-button>
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>   
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../common/http'; 
    import {banBackSpace} from '../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                scoreListId:"",
                data:[],
                content:[]
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            init(data){
                this.visible=true;
                this.data=[];
                this.scoreListId=data.id;
                this.getData();
            },
            getData(){
                let url  = this.scoreLissendNameListUrl;
                let data = {
                    scoreListId:this.scoreListId
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    console.log(res);
                    if(res.status==200){ 
                       this.data=res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                });
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            send(){
                let url  = this.scoreSendNoticeUrl;
                let data = {
                    scoreListId:this.scoreListId
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                        this.$parent.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/score/ScoreNotice.vue